import { UNIT_SYSTEM, UNIT_LABELS } from '../constants/UnitConsts';

export default {}

export const daysInMonth = (month, year) => {
  return new Date(year, month, 0).getDate();
}

export const convertDistance = (distance, unit) => unit === UNIT_SYSTEM.IMPERIAL ? Math.round(distance/1609.34*100)/100 : distance;

export const getUnitLabel = (unit) => UNIT_LABELS[unit] || UNIT_LABELS.METRIC;